export default "__VITE_ASSET__CYIzyb_N__"